import { useCallback } from 'react';

import theme from '../../setup/theme/theme';

const colors: string[] = [
  theme.palette.case.primary.p500,
  theme.palette.case.yellow.y500,
  theme.palette.case.orange.o500,
  theme.palette.case.red.r500,
  theme.palette.case.magenta.m500,
  theme.palette.case.blue.b500,
  theme.palette.case.cyan.c500,
  theme.palette.case.aquamarine.a500,
  theme.palette.case.neutral.n600,
  theme.palette.case.purple.p500,
];

const useBgColor = () => {
  const bgColor = useCallback((id: number) => {
    if (id) {
      return colors[id % colors.length];
    }
    const rand = Math.floor(Math.random() * colors.length);
    return colors[rand];
  }, []);

  return { bgColor };
};

export default useBgColor;
